import React, {useEffect, useState} from "react";
import InputForm from "./InputForm";
import {Colors} from "../../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import {Modal} from "react-bootstrap";
import {
  convertToString,
  formatAddress,
  formatAddressToArray,
  validarEspaciosEnBlanco,
  validArray
} from "../../util/functions";
import {isEmpty, isObject} from "../../util/is";
import {useDispatch} from "react-redux";
import {Controller, useController, useFormContext, useWatch} from "react-hook-form";
import '../../components/styles.css'
import {generalService} from "../../services/apiGenerales";
import {GlobalConstants} from "../../data/GlobalConstants";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";


const GeneradorDireccionesForm = ({className, identificador = "default", label = "Dirección", required = false, props = {}, customError = null, disabled = false}) => {

    const [ stateNomenclaturas, setStateNomenclaturas ] = useState([]);
    const { control, setValue } = useFormContext();
    const dispatch = useDispatch();

    const valueDireccion = useWatch({
      control,
      name: identificador
    })

    const handleChangeDireccion = (value, onChange) => {

      let arrValues = validArray(value).slice();

      if(arrValues.length > 1){

          let valorAnterior = arrValues[arrValues.length - 2];
          let valorNuevo = arrValues[arrValues.length - 1];

          if(isObject(valorAnterior) && isObject(valorNuevo)){

            arrValues.pop();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "No puedes agregar dos nomenclaturas seguidas" } });

          }

      }
      else if(arrValues.length === 1) {

          let valorNuevo = arrValues[arrValues.length - 1];

          if(!isObject(valorNuevo)){

            arrValues.pop();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "La dirección debe empezar con una nomenclatura" } });

          }

      }

      onChange(arrValues);

    }

    useEffect(() => {
      generalService.getNomenclatura().then(
        response => {
          const {status, msg, data} = response;

          if (status) {

            setStateNomenclaturas(data);

            if(!isEmpty(valueDireccion)){
              setValue(identificador, formatAddressToArray(valueDireccion, data))
            }

          }
          else{
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
          }

        },
        error => {
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
        }
      )
    }, [])

    return(
        <>

          <Controller
            rules={{ required: required }}
            control={control}
            defaultValue={[]}
            name={identificador}
            render={({ field: { onChange, onBlur, value} }) =>
              (
                <Autocomplete
                  value={validArray(value)}
                  multiple
                  id={identificador}
                  freeSolo
                  isOptionEqualToValue={(opción, valor) => false}
                  options={stateNomenclaturas}
                  getOptionLabel={(option) => option.text}
                  defaultValue={[]}
                  onBlur={onBlur}
                  onChange={(event, newValue) => handleChangeDireccion(newValue, onChange)}
                  className={`col-12 mt-3 mb-3`}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip variant="outlined" label={option?.text || option} {...getTagProps({ index })} />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Dirección"
                      placeholder="Ej: Carrera 1 2 3"
                      name={identificador}
                    />
                  )}
                />
              )
            }
          />


        </>
    )

}

export default GeneradorDireccionesForm;
